/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import DismantlerLayout from "../../layouts/DismantlerLayout";
import dismantlerImg from "../../assets/img/dismantlers/dismantler-gallery.jpg";
import {useOutletContext, useParams} from "react-router-dom";
import axios from "axios";
import Loader from "../../elements/loader";
import {getDismantler} from "../../Hooks/DesmantlerData";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {Lightbox} from "yet-another-react-lightbox";

const DismantlerGallery = () => {

    let params = useParams();

    const [merchant, setMerchant] = useState('');
    const [outletData, setOutletData] = useOutletContext();
    const [isLoading, setLoading] = useState(true);
    const [merchantLightBox, setMerchantLightBox] = useState([]);
    const [openLightBox, setOpenLightBox] = useState(false);

    const axiosJWT = useAxiosJTW();

    const getmerchantbymerchantid = (signal) => {
        axiosJWT.post('api/getmerchantbymerchantid', { merchantid: decodeURIComponent(params.merchantid) }, {signal}).then( (response) => {
            if(response.status === 200){
                setMerchant(response.data.merchant_info || {});

                const dismantler = getDismantler(response.data.merchant_info, response.data.schedule);
                setOutletData(dismantler);

                const merchantImagesArr = [];
                for (let index = 0; index < response.data.merchant_info.images.length; ++index) {
                    merchantImagesArr.push({ 'src': response.data.merchant_info.images[index].src}  );
                }
                setMerchantLightBox(merchantImagesArr);

                setLoading(false);
            }
        } ).catch((error) => {
            console.log(error);
        });

    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getmerchantbymerchantid(signal);

        return () => {controller.abort();}
    }, [params]);

    return (
        // <DismantlerLayout>
            <div className='page-body'>
                <div className='dismantler--container'>
                    <h2 className='dismantler__title'>Images from our Dismantler Storage </h2>

                    <div className='dismantlerGallery'>

                        {isLoading ? (
                            <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                        ) : (
                             merchantLightBox.length > 0 && <div className=''>
                                <div className='row'>
                                    {
                                        merchantLightBox.map((item, index) => {
                                            return(
                                                <div className='dismantlerGallery__item col' key={index} onClick={() => setOpenLightBox(true)}>
                                                    <img src={item.src} alt='dismantler' />
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                                <Lightbox
                                    open={openLightBox}
                                    close={() => setOpenLightBox(false)}
                                    slides={merchantLightBox}
                                />
                            </div>
                        )}

                    </div>

                </div>
            </div>
        // </DismantlerLayout>
    );
};

export default DismantlerGallery;
